angular.module('filters').filter('fromNow', function() {
  return function(input) {
    var hours;
    if (input) {
      hours = Math.round(moment(input).diff(moment(), 'hours', true));
      if (hours > 2 && hours <= 24) {
        return `in ${hours} hours`;
      }
      return moment(input).fromNow();
    }
  };
});
